<template>
  <modal size="xl" @close="$emit('close')">
    <template #head>
      <div class="modal-header">
        <h4 class="modal-title">Detail Log</h4>
        <div class="flex">
          <button
            class="btn btn-info btn-sm waves-effect waves-light m-l-5"
            type="button"
            @click="sendMailShow = true"
          >
            <span>Send Logs</span>
          </button>
          <button class="close" type="button" @click="$emit('close')">×</button>
        </div>
      </div>
    </template>
    <template #content>
      <loadArea v-if="data == null"></loadArea>
      <template v-if="data != null">
        <ul>
          <li><strong>Method:</strong>{{ log.FunctionName }}</li>
          <li>
            <strong>Date:</strong
            >{{ $moment($diffToGMT(log.Date)).format("DD.MM.YYYY HH:mm") }}
          </li>
          <li><strong>Hotel:</strong>{{ log.HotelName }}({{ log.HotelId }})</li>
          <li><strong>Url:</strong>{{ log.Url }}</li>
          <li><strong>ErrorMessage:</strong>{{ log.ErrorMessage }}</li>
        </ul>
        <div class="row m-0 border-top">
          <div class="col-6 p-t-10">
            <div class="row">
              <small class="col p-b-10 block">Raw</small>
              <div class="col-auto">
                <button
                  class="btn btn-info btn-xs waves-effect waves-light m-l-5 kr-copybtn"
                  :class="{ done: copied === 'req' }"
                  type="button"
                  @click="copy('req')"
                >
                  <i
                    class="fa m-r-5"
                    :class="copied === 'req' ? 'fa-check' : 'fa-copy'"
                  ></i>
                  <span>Copy</span>
                </button>
              </div>
            </div>
            <pre class="m-0">{{ setResponse(data.RequestBody) }}</pre>
          </div>
          <div class="col-6 p-t-10 border-left">
            <div class="row">
              <small class="col p-b-10 block">Result</small>
              <div class="col-auto">
                <button
                  class="btn btn-info btn-xs waves-effect waves-light m-l-5 kr-copybtn"
                  :class="{ done: copied === 'res' }"
                  type="button"
                  @click="copy('res')"
                >
                  <i
                    class="fa m-r-5"
                    :class="copied === 'res' ? 'fa-check' : 'fa-copy'"
                  ></i>
                  <span>Copy</span>
                </button>
              </div>
            </div>
            <pre class="m-0">{{ setResponse(data.ResponseBody) }}</pre>
          </div>
        </div>
      </template>
    </template>
  </modal>
  <modal title="Send Log" @close="sendMailShow = false" v-if="sendMailShow">
    <template #content>
      <Form
        method="dialog"
        v-slot="{ errors }"
        class="floating-labels p-1rem row align-items-start"
        ref="form"
      >
        <formGroup
          :title="'Email'"
          v-model="sendModel.Mail"
          :errors="errors"
          :rules="{ required: true, max: 100, email: true }"
          @keydown.enter="send"
        ></formGroup>
        <formGroup
          :title="'Note'"
          as="textarea"
          v-model="sendModel.Note"
          :errors="errors"
          @keydown.enter="send"
        ></formGroup>
      </Form>
    </template>
    <template #foot>
      <Btn
        class="btn-success btn-md"
        @click="send"
        :disabled="sendProcess"
        :process="sendProcess"
        >Send Log</Btn
      >
    </template>
  </modal>
</template>

<script>
import axios from "axios";
export default {
  name: "show",
  props: {
    log: Object,
  },
  data() {
    return {
      addCurrenciesOpen: false,
      model: {
        Active: false,
        CurrencyCode: "",
        DurationBased: false,
        Id: null,
        IncreementDayCount: null,
        IsPortal: false,
        Logo: null,
        MainOperatorId: null,
        MaxDayCount: null,
        MaxHotelCount: null,
        Name: "",
        OutputPort: null,
        RegionBased: false,
        ResponseItemCount: null,
        ScanModel: null,
        ShortName: "",
        UsingSameHotelsWithMainOperator: false,
      },
      data: null,
      // 'req' | 'res' | null -> hangi Copy dugmesi tik gosteriyor
      copied: null,
      copyTimer: null,
      process: false,
      rescanShow: false,
      sendModel: {
        Mail: "",
        Note: "",
      },
      sendProcess: false,
      sendMailShow: false,
    };
  },
  created() {
    axios
      .get(this.log.LogFileUrl)
      .then((response) => {
        this.data = {
          ...response.data,
        };
        // Iki govde BAGIMSIZ parse edilir. Onceki halde her biri kendi
        // try/catch'inde bare `return` yapiyordu: RequestBody parse edilemezse
        // fonksiyondan cikiliyor ve ResponseBody HIC parse edilmiyordu (ham
        // escape'li string olarak basiliyordu). setResponse zaten parse
        // edemedigini oldugu gibi geri veriyor.
        this.data.RequestBody = this.setResponse(response.data.RequestBody);
        this.data.ResponseBody = this.setResponse(response.data.ResponseBody);
      })
      .catch((err) => {
        // data null kalirsa <loadArea v-if="data == null"> sonsuza kadar doner.
        this.data = { RequestBody: "", ResponseBody: "", DatabaseRecord: null };
        console.error("Log dosyasi okunamadi:", this.log.LogFileUrl, err);
      });
  },
  methods: {
    copy(which) {
      const body =
        which === "req" ? this.data.RequestBody : this.data.ResponseBody;
      const text = JSON.stringify(this.setResponse(body), null, 2);
      // Basari geri bildirimi TOAST DEGIL, dugmenin uzerinde: kullanicinin
      // dikkati zaten orada. Hata durumunda toast kaliyor (clipboardCopy icinde),
      // cunku "https gerekiyor" gibi bir aciklama dugmeye sigmaz.
      Promise.resolve(this.$root.clipboardCopy(text, true)).then((ok) => {
        if (ok === false) return;
        this.copied = which;
        clearTimeout(this.copyTimer);
        this.copyTimer = setTimeout(() => {
          this.copied = null;
        }, 1600);
      });
    },
    setResponse(data) {
      try {
        return JSON.parse(data);
      } catch (error) {
        return data;
      }
    },
    send() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.sendProcess = false;
          this.$appAxiosAdmin
            .post(`KOLAYREZ/PMSLogs/Send`, {
              Id: this.log.Id,
              Email: this.sendModel.Mail,
              Note: this.sendModel.Note,
            })
            .then(() => {
              this.sendProcess = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text: "Log send",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              this.sendMailShow = false;
            })
            .catch((err) => {
              this.sendProcess = false;
              this.$isError(err);
            });
        }
      });
    },
  },
  beforeUnmount() {
    // Modal kapandiktan sonra state'e yazmasin
    clearTimeout(this.copyTimer);
  },
};
</script>

<style scoped>
/* Kopyalama onayi: SADECE ikon fa-copy -> fa-check olur, etiket "Copy" kalir.
   Etiket degismedigi icin genislik sabit, min-width gerekmiyor.
   Renk mavi tonlarinda kaliyor (yesil yok): onay icin bir tik koyu maviye gecer. */
.kr-copybtn {
  transition: background-color 0.18s ease, border-color 0.18s ease;
}
/* METIN RENGI ACIKCA SABITLENDI. Sebep: style.css:1024 `.btn-info`in ARKA PLANINI
   eziyor ama `color`i yeniden tanimlamiyor; boylece metin rengi 12 stylesheet
   arasindaki cascade'e kaliyor ve tiklandiktan sonra (odak dururken) koyuya
   donebiliyor. Tum durumlar icin beyaz sabitleniyor. */
.kr-copybtn,
.kr-copybtn:hover,
.kr-copybtn:focus,
.kr-copybtn:active,
.kr-copybtn.focus,
.kr-copybtn.active,
.kr-copybtn:not(:disabled):not(.disabled):active,
.kr-copybtn:not(:disabled):not(.disabled):active:focus,
.kr-copybtn.done,
.kr-copybtn.done:hover,
.kr-copybtn.done:focus,
.kr-copybtn.done:active {
  color: #fff;
}
/* ZEMIN TUTARSIZLIGI: olculdu -> normal #1e88e5, :focus #028ee1, :active
   #117a8b (Bootstrap'in ORIJINAL TEAL'i). style.css:1024-1045 `.btn-info`in
   normal/hover/focus zeminini maviye cevirmis ama `:active`i ezmemis, o yuzden
   tiklarken dugme teal'e donuyordu. Uc durum da mavi ailesine sabitleniyor.
   NOT: bu bug uygulamadaki TUM .btn-info dugmelerinde var; burada yalniz bu
   dugme icin cozuldu. */
.kr-copybtn:focus,
.kr-copybtn.focus {
  background-color: #1e88e5;
  border-color: #1e88e5;
}
/* Bootstrap'in kurali hem `.active` (literal class) hem `:active` (pseudo)
   varyantini iceriyor ve 4 sinif specificity'sinde -> ikisini de ayni sekilde
   karsilamak gerekiyor, yoksa biri teal kaliyor. */
.kr-copybtn:active,
.kr-copybtn.active,
.kr-copybtn:not(:disabled):not(.disabled):active,
.kr-copybtn:not(:disabled):not(.disabled).active,
.kr-copybtn:not(:disabled):not(.disabled):active:focus,
.kr-copybtn:not(:disabled):not(.disabled).active:focus {
  background-color: #1565c0;
  border-color: #1565c0;
}
.kr-copybtn.done,
.kr-copybtn.done:hover,
.kr-copybtn.done:focus,
.kr-copybtn.done:active,
.kr-copybtn.done:not(:disabled):not(.disabled):active {
  background-color: #1565c0;
  border-color: #1565c0;
}
/* Tik yumusak girsin */
.kr-copybtn i {
  transition: transform 0.18s ease;
}
.kr-copybtn.done i {
  transform: scale(1.2);
}
@media (prefers-reduced-motion: reduce) {
  .kr-copybtn,
  .kr-copybtn i {
    transition: none;
  }
}
pre {
  box-shadow: none;
}
ul li {
  padding: 5px 10px;
  font-size: 14px;
}
ul li:nth-child(even) {
  background: #f6f6f6;
}
</style>
